import { render, staticRenderFns } from "./transcription_skeleton.vue?vue&type=template&id=4e295bf6&scoped=true&"
var script = {}
import style0 from "./transcription_skeleton.vue?vue&type=style&index=0&id=4e295bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e295bf6",
  null
  
)

export default component.exports